import { render, staticRenderFns } from "./CourierPicker.vue?vue&type=template&id=4ad54d00"
import script from "./CourierPicker.vue?vue&type=script&lang=js"
export * from "./CourierPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports